import { defaultPages, defaultSections, sectionTemplate } from "../data/default-sections";

import { uploadFile } from "../utils/uppyFactory";
import { persistActivityGroupConfig, assignCustomCodesToActivityGroups } from "../api/index";

const saveConfigPage = (config, configReport) => {

  const indexPage = configReport.pages.findIndex(page => page.id === config.id);

  if (indexPage !== -1) {

    // TODO: despues de un tiempo eliminar todo el contenido de este if
    if (! config.settings && config.code === 'RAG_SUMMARY') {
      if (config.id === 1) { config.id = 2; }

      config.settings = {
        showGroupProgress: config.showGroupProgress ?? 'parent',
        customGroups: config.customGroups ?? [],
      };

      delete config.showGroupProgress;
      delete config.customGroups;
    }

    configReport.pages[indexPage] = config;

  } else {
    // Si no existe, agregar como nuevo
    configReport.pages.push(config);
  }
}

const saveConfigSection = (config, configReport) => {

  const indexSection = configReport.sections.findIndex(section => section.id === config.id);
  if (indexSection > -1) {
    configReport.sections[indexSection] = config;
  } else {
    // Si no existe, agregar como nuevo
    configReport.sections.push(config);
  }
}

const addReportConfig = (config, type, configReport) => {
  if (type === 'pages') {
    const configPage = defaultPages.find(page => page.code === config.code);
    saveConfigPage(configPage, configReport);
  }
  else if (type === 'sections') {
    let configSection = defaultSections.find(section => section.code === config.code);
    if (!configSection) {
      configSection = { ...sectionTemplate, code: config.code, name: config.name };
    }

    // 1. Obtener el ID máximo actual
    const maxId = Math.max(
      0,
      ...configReport.sections
        .filter(item => item.id && item.id > 0)
        .map(item => item.id)
    );

    // 2. Asignar nuevos ID a los que no lo tienen
    configSection.id = maxId + 1;
    // configReport.forEach(item => {
    //   if (!item.id || item.id === 0) {
    //     maxId += 1;
    //     item.id = maxId;
    //   }
    // });

    saveConfigSection(configSection, configReport);

  }
}

const normalizeSections = (sections) => {
  let maxId = Math.max(
    0, sections
      .filter(item => item.id && item.id > 0)
      .map(item => item.id)
  );

  return sections.map(cfg => {
    if (!cfg.id || cfg.id === 0) { cfg.id = ++maxId; }

    return {
      id: cfg.id,
      code: cfg.code,
      name: cfg.name,
      description: cfg.description || '',
      visible: cfg.visible,
      canDisableSection: cfg.canDisableSection || false,
      isUserManaged: cfg.isUserManaged,
      numberOfExtraImages: cfg.numberOfExtraImages || 0,
      groupId: cfg.groupId || null,
      hasAssociatedGroup: cfg.hasAssociatedGroup,
      documentType: cfg.documentType || null,
      userCanDefineLegend: cfg.userCanDefineLegend || false,
      ganttLandscape: cfg.ganttLandscape || false,
      ganttUserCanChangeOrientation: cfg.ganttUserCanChangeOrientation || false,
      isEditable: cfg.isEditable || true,
      type: cfg.type || 'section',
      customizationType: cfg.customizationType || 'user-editable',
    }
  })
}

const normalizePages = (pages) => {
  return pages.map(page => {
    return {
      id: page.id,
      code: page.code,
      name: page.name,
      description: page.description || '',
      visible: page.visible,
      settings: page.settings || {},
      isUserManaged: page.isUserManaged || false,
      isEditable: page.isEditable || false,
      type: page.customizationType || 'custom',
      customizationType: page.customizationType || 'admin-only',
    }
  })
}

const saveReportConfig = async (projectId, configReport) => {
  try {
    // Primero preguntamos si tiene configuración personalizada para la portada del reporte
    const cfgCover = configReport.pages.find(page => page.code === 'REPORT_COVER');

    if (cfgCover?.settings?.image_cover?.file) {
      const { file, response } = await uploadFile(cfgCover.settings.image_cover.file);

      Object.assign(cfgCover.settings.image_cover, {
        type: 'file', // 'file' o 'url' camabia a url en backend si es necesario
        name: file.name, // nombre del archivo es cambiado en el backend
        mimeType: file.type, // tipo de archivo
        url: response.body.key, // URL cuando es file es la key de la respuesta de S3
        file: null, // si es un archivo temporal no es necesario enviar podriamos mandar null o directo no mandar
      });
    }

    // TODO: falta validacion de datos antes
    const successAssign = await assignCustomCodes(configReport);
    if (!successAssign) throw new Error('No se pudieron asignar los códigos personalizados.');

    // TODO: mismo que secciones este caso es necesario crear un template de paginas si sera lo mismo
    const sectionsReport = normalizeSections(configReport.sections);
    const pagesReport = normalizePages(configReport.pages);

    const activityGroupsConfig = {
      view: {
      },

      reports: {
        detailed: {
          pages: pagesReport,
          sections: sectionsReport,
        },
      }
    }

    await persistActivityGroupConfig(projectId, { activity_groups: activityGroupsConfig });

    return { pages: pagesReport, sections: sectionsReport };

  } catch (err) {
    console.log('Error saving config:', err);
    throw err;
  }
}

const assignCustomCodes = async (configReport) => {
  try {
    const prevAssignedIds = configReport.sections
      .map(cfg => cfg.prevGroupId)
      .filter(id => !!id);

    const newAssignedIds = configReport.sections
        .map(cfg => cfg.groupId)
        .filter(id => !!id);

    const customCodeArray = configReport.sections
        .filter(cfg => cfg.groupId)
        .map(cfg => ({
            id: cfg.groupId,
            code_custom: cfg.code
        }));

    prevAssignedIds.forEach(id => {
        if (!newAssignedIds.includes(id)) {
            customCodeArray.push({ id, code_custom: null });
        }
    });

    if ( customCodeArray.length > 0 ) {
      await assignCustomCodesToActivityGroups(customCodeArray);
    }

    return true;

  } catch (e) {
    console.error('Error assigning custom codes:', e);
    return false;
  }
}

export {
  saveConfigPage,
  saveConfigSection,
  addReportConfig,
  saveReportConfig,
}